export default "__VITE_ASSET__DaB2uOwS__"